// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Home } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconHome(props: any) {
    return <IconBase icon={Home} {...props} />
  }

  export default IconHome
  